// App.tsx (excerpt)
import { createBrowserRouter } from 'react-router-dom';
import AdminRoutes from './Adminroutes';
import PhysicianRoutes from './PhysicianRoutes';
import ReviewerRoutes from './ReviewerRoutes';
import LandingPage from '../components/UI/landingpage';
import Login from '../components/UI/Login';
import Signup from '../components/UI/Signup';
import ForgotPassword from '../components/UI/ForgotPassword';
import ResetPassword from '../components/UI/ResetPassword';
import VerifyPasswordResetOTP from '../components/UI/VerifyPasswordResetOTP';
import OtpVerification from '../components/UI/OtpVerification';
import AdminDashboard from '../components/Admin/AdminDashboard';
import PhysicianDashboard from '../components/Physician/PhysicianDashboard';
import ReviewerDashboard from '../components/Reviewer/ReviewerDashboard';
import ProtectedRoute from '../components/common/ProtectedRoute';

const router = createBrowserRouter([
  // Public routes
  { path: '/', element: <LandingPage /> },
  { path: '/login', element: <Login /> },
  { path: '/signup', element: <Signup /> },
  { path: '/verify-otp', element: <OtpVerification /> },
  { path: '/forgot-password', element: <ForgotPassword /> },
  { path: '/verify-password-reset-otp', element: <VerifyPasswordResetOTP /> },
  { path: '/reset-password', element: <ResetPassword /> },

  // Admin routes
  {
    path: '/admin',
    element: (
      <ProtectedRoute requiredRole={['admin', 'super-admin']}>
        <AdminRoutes />
      </ProtectedRoute>
    ),
    children: [
      { path: '', element: <AdminDashboard /> },
      { path: 'cases', element: <AdminDashboard /> },
      { path: 'users', element: <AdminDashboard /> },
      { path: 'settings', element: <AdminDashboard /> },
      { path: 'profile', element: <AdminDashboard /> },
      { path: 'help', element: <AdminDashboard /> },
      { path: 'reviewer-management', element: <AdminDashboard /> },
      { path: 'admin-management', element: <AdminDashboard /> },
      { path: 'logout', element: <AdminDashboard /> },
      // ...other admin pages
    ],
  },

  // Physician routes
  {
    path: '/physician',
    element: (
      <ProtectedRoute requiredRole={['physician']}>
        <PhysicianRoutes />
      </ProtectedRoute>
    ),
    children: [
      { path: '', element: <PhysicianDashboard /> },
      { path: 'predict', element: <PhysicianDashboard /> },
      { path: 'cases', element: <PhysicianDashboard /> },
      { path: 'profile', element: <PhysicianDashboard /> },
      { path: 'help', element: <PhysicianDashboard /> },
      { path: 'logout', element: <PhysicianDashboard /> },
      // ...other physician pages
    ],
  },

  // Reviewer routes
  {
    path: '/reviewer',
    element: (
      <ProtectedRoute requiredRole={['specialist']}>
        <ReviewerRoutes />
      </ProtectedRoute>
    ),
    children: [
      { path: '', element: <ReviewerDashboard /> },
      { path: 'my-cases', element: <ReviewerDashboard /> },
      { path: 'review-cases', element: <ReviewerDashboard /> },
      { path: 'profile', element: <ReviewerDashboard /> },
      { path: 'help', element: <ReviewerDashboard /> },
    ],
  },
]);

export default router;